import React, { useState } from 'react';
import { sendPasswordResetEmail, sendEmailVerification } from 'firebase/auth';
import { auth } from '../../../firebase';

// Account credentials remain in Firebase Auth. Never collect or expose provider keys.
export default function SecuritySection({ currentUser, t }) {
  const [busy, setBusy] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState(false);
  const [verified, setVerified] = useState(currentUser.emailVerified);
  const passwordAccount = currentUser.providerData?.some(item => item.providerId === 'password');
  async function run(action) {
    setBusy(action); setMessage(''); setError(false);
    try {
      if (action === 'password') await sendPasswordResetEmail(auth, currentUser.email);
      else if (action === 'verify') await sendEmailVerification(currentUser);
      else { await currentUser.reload(); await currentUser.getIdToken(true); setVerified(currentUser.emailVerified); }
      setMessage(action === 'password' ? 'security.resetSent' : action === 'verify' ? 'security.verificationSent' : currentUser.emailVerified ? 'security.emailVerified' : 'security.notVerifiedYet');
    } catch { setError(true); setMessage('security.requestFailed'); }
    finally { setBusy(''); }
  }
  return <section className="profile-panel">
    <div className="profile-panel-header"><div><h2>{t('security.title')}</h2><p>{t('security.description')}</p></div><i className="fa-solid fa-shield-halved settings-section-icon" aria-hidden="true" /></div>
    <div className="settings-security-row"><div><strong>{t('security.email')}</strong><p>{currentUser.email}</p></div>
      <span className={`settings-status ${verified ? 'success' : ''}`}>{t(verified ? 'security.verified' : 'security.unverified')}</span></div>
    {!verified && <div className="profile-panel-actions profile-panel-actions--left">
      <button type="button" className="profile-btn-secondary" disabled={Boolean(busy)} onClick={() => run('verify')}>{t('security.sendVerification')}</button>
      <button type="button" className="profile-inline-action" disabled={Boolean(busy)} onClick={() => run('refresh')}>{t('security.checkVerification')}</button>
    </div>}
    <div className="settings-security-row"><div><strong>{t('security.password')}</strong><p>{t(passwordAccount ? 'security.passwordDescription' : 'security.externalSignIn')}</p></div>
      {passwordAccount && <button type="button" className="profile-btn-secondary" disabled={Boolean(busy)} onClick={() => run('password')}>{t('security.resetPassword')}</button>}</div>
    {message && <p role={error ? 'alert' : 'status'} className={error ? 'settings-error' : 'settings-footnote'}>{t(message)}</p>}
  </section>;
}
